import Skeleton from "./Skeleton";

// Props interface for CardSkeleton
interface CardSkeletonProps {
  count?: number;
  className?: string;
  layout?: "grid" | "stack";
  showIcon?: boolean;
}

// CardSkeleton Component - Loading placeholder for metric/stat cards
const CardSkeleton: React.FC<CardSkeletonProps> = ({
  count = 1,
  className = "",
  layout = "grid",
  showIcon = true,
}) => {
  // Single card skeleton structure
  const SingleCardSkeleton = () => (
    <div className="rounded-xl border border-gray-200 bg-white p-5 dark:border-gray-800 dark:bg-white/[0.03] sm:p-6">
      <div className="flex items-start justify-between">
        <div className="flex-1">
          {/* Title */}
          <Skeleton height={16} width="60%" className="mb-3" />

          {/* Value */}
          <Skeleton height={32} width="80%" className="mb-2" />

          {/* Additional info or change indicator */}
          <Skeleton height={14} width="40%" />
        </div>

        {/* Icon placeholder */}
        {showIcon && (
          <div className="ml-4">
            <Skeleton width={48} height={48} rounded="lg" />
          </div>
        )}
      </div>
    </div>
  );

  // Render multiple cards
  const cards = Array.from({ length: count }).map((_, index) => (
    <SingleCardSkeleton key={index} />
  ));

  // Return with appropriate layout
  if (layout === "grid") {
    return (
      <div
        className={`grid gap-4 sm:gap-6 ${
          count === 1
            ? "grid-cols-1"
            : count === 2
            ? "grid-cols-1 sm:grid-cols-2"
            : count === 3
            ? "grid-cols-1 sm:grid-cols-2 lg:grid-cols-3"
            : "grid-cols-1 sm:grid-cols-2 lg:grid-cols-4"
        } ${className}`}
      >
        {cards}
      </div>
    );
  }

  // Stack layout
  return <div className={`space-y-4 sm:space-y-6 ${className}`}>{cards}</div>;
};

export default CardSkeleton;
